import { jsxs as f, jsx as l } from "react/jsx-runtime";
import u from "react";
import { Interactive as h } from "../Interactive/Interactive.js";
import { clsx as t } from "../../utils/clsx.js";
import '../../assets/Popover.css';const x = "_root_14ed3_1", N = "_active_14ed3_4", M = "_popover_14ed3_4", g = "_appearance_14ed3_1", o = {
  root: x,
  active: N,
  popover: M,
  appearance: g,
  "pos-top-right": "_pos-top-right_14ed3_37"
}, R = u.forwardRef(function(r, s) {
  const {
    at: c,
    popover: p,
    children: a,
    active: n = !1,
    onMouseEnter: i,
    onMouseLeave: v,
    onMouseDown: _
  } = r, e = n, m = t(o.root, {
    [o.active]: e
  }), d = t(o.popover, o[`pos-${c}`]);
  return /* @__PURE__ */ f(
    h,
    {
      ref: s,
      className: m,
      onMouseEnter: i,
      onMouseLeave: v,
      onMouseDown: _,
      children: [
        a(e),
        e && /* @__PURE__ */ l("div", { className: d, children: p })
      ]
    }
  );
});
export {
  R as Popover
};
